export default function style(set) {
  return {
    wrapperWidthReady: false,
    headerHeight: 60,
    columnSize: 240,
    column: 20,
    wrapperWidth: 0,
    isNewLayout: false,
    sideNavVisible: false,
  };
}
